import { Tabs } from 'antd'
import React, { useState } from 'react'
import BuilderLayout from '../../layouts/builderLayout/BuilderLayout'
import { Container } from './Styled'
import AnalyticsGlobal from './analyticsGlobal/AnalyticsGlobal';
import AnalyticsByEvent from './analyticsByEvent/AnalyticsByEvent';
import { createLoadingSelector } from '../../../business/selectors/loadingSelectors';
import { useSelector } from 'react-redux';
import { RootState } from '../../../model/rootReducer';
import Loader from '../../system/loader/Loader';
import moment from 'moment';
import { AnalyticsDate } from '../../../model/analytics/types';
const { TabPane } = Tabs;

const dates: AnalyticsDate = {
    startDate: moment().add(-7, 'days'),
    endDate: moment(),
    dateFormat: 'YYYY-MM-DD'
}

const Analytics: React.FunctionComponent = (props: any) => {
    const loadingSelector = createLoadingSelector([
        'GET_ALL_EVENTS',
    ])
    const isFetching = useSelector((state: RootState) => loadingSelector(state))
    const globalPerf = useSelector(
        (state: RootState) => state.analytics.globalPerf
    )

    return (
        <BuilderLayout
            onBackDestination="/"
            title={'Analytique'}
            subTitle={
                "Analyse"
            }
        >
            <Loader isLoading={isFetching}>
                <Container>
                    <Tabs defaultActiveKey="1" >
                        <TabPane tab="Global" key="1">
                            <AnalyticsGlobal globalPerf={globalPerf} dates={dates} />
                        </TabPane>
                        <TabPane tab="Par événement" key="2">
                            <AnalyticsByEvent globalPerf={globalPerf} dates={dates} />
                        </TabPane>
                    </Tabs>
                </Container>
            </Loader>
        </BuilderLayout >
    )

}

export default Analytics